/**
 * dg-money-format.js
 * Moves the $ sign to the right of every price on the page.
 * Converts "$125.25" → "125.25 $"
 * Works on initial load AND dynamic content (AJAX cart, quick view, etc.)
 */
(function () {
    'use strict';

    // Matches $X, $X.XX, $X,XXX.XX — with or without a space after $
    var MONEY_RE = /\$\s?(\d[\d,]*\.?\d*)/g;

    function reformat(text) {
        return text.replace(MONEY_RE, function (_, amount) {
            return amount + '\u00a0$'; // non-breaking space before $
        });
    }

    // Walk only text nodes inside an element, skip scripts & styles
    function reformatNode(root) {
        var walker = document.createTreeWalker(
            root,
            NodeFilter.SHOW_TEXT,
            {
                acceptNode: function (node) {
                    var tag = node.parentElement && node.parentElement.tagName;
                    if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT') {
                        return NodeFilter.FILTER_REJECT;
                    }
                    // Only process nodes that actually contain a $ followed by digits
                    return /\$\s?\d/.test(node.nodeValue)
                        ? NodeFilter.FILTER_ACCEPT
                        : NodeFilter.FILTER_SKIP;
                }
            },
            false
        );

        var nodes = [];
        var node;
        while ((node = walker.nextNode())) {
            nodes.push(node);
        }
        nodes.forEach(function (n) {
            n.nodeValue = reformat(n.nodeValue);
        });
    }

    // Initial pass over the whole document
    function runInitial() {
        reformatNode(document.body);
    }

    // MutationObserver: watch for dynamic insertions (cart, quick view, etc.)
    function watchMutations() {
        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                mutation.addedNodes.forEach(function (added) {
                    if (added.nodeType === Node.ELEMENT_NODE) {
                        reformatNode(added);
                    } else if (added.nodeType === Node.TEXT_NODE) {
                        if (/\$\s?\d/.test(added.nodeValue)) {
                            added.nodeValue = reformat(added.nodeValue);
                        }
                    }
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            runInitial();
            watchMutations();
        });
    } else {
        runInitial();
        watchMutations();
    }
}());
